import { defaultProps } from 'recompose'
import { Col as FlexCol, Grid as FlexGrid, Row as FlexRow } from 'react-flexbox-grid'

const gridStyle = { paddingLeft: 0, paddingRight: 0 }

export const Col = defaultProps()(FlexCol)

export const Grid = defaultProps({ style: gridStyle })(FlexGrid)

export const Row = defaultProps()(FlexRow)
